module.exports = __webpack_public_path__ + "img/auth_1.43899a6e.png";